import HeaderPortal from "components/portal/header-portal";
import { List, Icon } from "components";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "ui/components/dropdown-menu";
import { Button } from "ui/components/button";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { eventBus } from "utils/eventBus";
import CreateDeliverableDialog from "./input";
import { useRemoveDeliverable } from "./mutation";
import { MENU } from "icons";

export default function Deliverables() {
    const { casestudyId } = useParams();
    const [dialogOpen, setDialogOpen] = useState(false);
    const removeDeliverable = useRemoveDeliverable({
        onSuccess: () => {
            eventBus.emit("refresh:list", `deliverablesdeliverables${casestudyId}`);
        },
    });
    const fields = [
        "id",
        "name",
        "url",
        "case_study.id",
    ];
    const columns = [
        {
            id: "name",
            header: "Name",
            accessorKey: "name",
        },
        {
            id: "url",
            header: "URL",
            accessorKey: "url",
        },
        {
            id: "actions",
            header: "",
            accessorKey: "id",
            cell: ({ row }) => {
                const id = row.original.id;
                return (
                    <div className="flex items-center gap-2 justify-end opacity-0 group-hover:opacity-100 transition">
                        <DropdownMenu>
                            <DropdownMenuTrigger asChild>
                                <Button size="icon" variant="outline">
                                    <Icon icon={MENU} className="size-4" />
                                </Button>
                            </DropdownMenuTrigger>
                            <DropdownMenuContent>
                                <DropdownMenuItem
                                    onClick={() => removeDeliverable.mutateAsync({ id })}
                                    disabled={removeDeliverable.isPending}
                                    className="cursor-pointer"
                                >
                                    Delete
                                </DropdownMenuItem>
                            </DropdownMenuContent>
                        </DropdownMenu>
                    </div>
                );
            },
            sortable: false,
            meta: { align: "right" },
        },
    ];

    const defaultFilters = {
        case_study: {
            id: {
                _eq: casestudyId,
            }
        },
    };

    const handleCreate = () => {
        setDialogOpen(true);
    };

    return (
        <div className="flex-1">
            <HeaderPortal>
                <Button onClick={handleCreate}>
                    Add
                </Button>
            </HeaderPortal>
            <List
                title="Deliverables"
                storageKey={`deliverables${casestudyId}`}
                endPoint="deliverables"
                filters={defaultFilters}
                columns={columns}
                meta={{ fields }}
                hidePagination={true}
                showSearch={false}
                perPage={25}
                sortBy="date_created"
            />
            <CreateDeliverableDialog
                open={dialogOpen}
                onOpenChange={setDialogOpen}
            />
        </div>
    );
}
